<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-package'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [isImageIcon]="false"
  [dropdownEnabled]="false"
  [hasFooter]="false"
  [hasValueOnly]="true"
  [hasDifference]="false"
></app-kpi-widget>